module.exports = __webpack_public_path__ + "static/media/Chevron.7621a968.svg";